import React, { Component, useEffect, useState } from "react";
import {
  Edit,
  SimpleForm,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  REDUX_FORM_NAME,
  required,
  AutocompleteInput,
  NumberInput,
  SimpleFormIterator,
  ArrayInput,
  TopToolbar,
  AutocompleteArrayInput,
  ReferenceInput,
  RefreshButton,
  FormDataConsumer,
  SaveButton,
  Toolbar,
  DeleteButton,
  TextInput,
  GET_LIST,
  minLength,
  maxLength,
  regex,
  email,
  usePermissions,
} from "react-admin";
// import { change } from 'redux-form';
// import { cardActionStyle, sdoStatuses, LineItemsSideComponent } from './common';
import { getLocalStorageKey } from "../common/common";
import myDataProvider from "../myRestProvider";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  DigitalOrderSystem,
  EmptyPagination,
  Papa,
} from "../common/common";
import Swal from "sweetalert2";

const SalesOfficersEdit = (props) => {
  let webUrl = window.location.href;
  var words = webUrl.split("/");
  var searcher = "sales_officers";
  var numberIndex = words.findIndex((word) => word == searcher);
  var urlId = words[numberIndex + 1];
  const [sale_officer, setSale_officer] = useState({});
  const [businessesData, setBusinessesData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [validationEmailError, setValidationEmailError] = useState(false);
  const [validationPhoneError, setValidationPhoneError] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [saleOffEmail, setSaleOffEmail] = useState("");
  const [saleOffPhone, setSaleOffPhone] = useState("");
  const [saleOffStatus, setSaleOffStatus] = useState("");

  const [originalList, setOriginalList] = useState([]);
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [saleOffList, setSaleOffList] = useState([]);
  const [isTradeDeveloper, setIsTradeDeveloper] = useState("");
  let locale = getLocalStorageKey("locale");

  const navigate = useNavigate();
  const permissions = usePermissions();

  const [parsedCSVdata, setParsedCSVdata] = useState([]);
  const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
  const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
  const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] =
    useState(0);
  const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] =
    useState(false);

  const handleFile = (e) => {
    let file = null;
    file = e.target.files[0];
    const fileType = file.name.substring(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    if (
      file === null ||
      typeof file === "undefined" ||
      file === "" ||
      typeof file === undefined ||
      fileType.toLowerCase() !== "csv"
    ) {
      Swal.fire({
        text: "Please choose a valid .csv file.",
        confirmButtonText: `OK`,
        icon: "error",
      });
      file = null;
      console.log("bad file");
    } else {
      console.log([e.target.name], e.target.files[0]);
      setUnregisteredRetailers([]);
      setPasrsedSimilarDataLength(0);
      setPasrsedDifferentDataLength(0);
      // this.setState({
      //   unregisteredRetailers: [],
      //   pasrsedSimilarDataLength: 0,
      //   pasrsedDifferentDataLength: 0,
      // });
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const checkValidHeader = Object.keys(results.data[0]);
          // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
          if (
            checkValidHeader.includes("COMPANYNAME") &&
            checkValidHeader.includes("SAPID")
          ) {
            const parseddata =
              permissions.permissions === "isSap"
                ? results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + "-0000" + item.SAPID,
                    label: item.COMPANYNAME + "-0000" + item.SAPID,
                    sap: "0000" + item.SAPID.trim(),
                  }))
                : results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + " " + item.SAPID,
                    label: item.COMPANYNAME + " " + item.SAPID,
                    sap: item.SAPID.trim(),
                  }));
            console.log(parseddata);
            let pasrsedSimilarData = [];
            pasrsedSimilarData = originalList.filter((a1) =>
              parseddata.some((a2) => a1.sap === a2.sap)
            );
            if (pasrsedSimilarData && pasrsedSimilarData.length) {
              const similarArray =
                saleOffList !== null
                  ? saleOffList.filter(
                      ({ sap: id1 }) =>
                        !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)
                    )
                  : [];
              setSaleOffList([...similarArray, ...pasrsedSimilarData]);
              setPasrsedSimilarDataLength(pasrsedSimilarData.length);
              // this.setState({ saleOffList: [...similarArray, ...pasrsedSimilarData], pasrsedSimilarDataLength: pasrsedSimilarData.length })
            }
            const pasrsedDifferentData = parseddata.filter((a1) =>
              pasrsedSimilarData.every((a2) => a1.sap !== a2.sap)
            );
            if (pasrsedDifferentData && pasrsedDifferentData.length) {
              console.log(pasrsedDifferentData, pasrsedDifferentData.length);
              setUnregisteredRetailers([...pasrsedDifferentData]);
              setPasrsedDifferentDataLength(pasrsedDifferentData.length);
              // this.setState({ unregisteredRetailers: [...pasrsedDifferentData], pasrsedDifferentDataLength: pasrsedDifferentData.length })
            }
            console.log("seprated", pasrsedSimilarData, pasrsedDifferentData);
            setParsedCSVdata([...parseddata]);
            // this.setState({ parsedCSVdata: [...parseddata] });
          } else {
            file = null;
            Swal.fire({
              text: "File headers do not match. Kindly download and refer the sample file.",
              confirmButtonText: `OK`,
              icon: "error",
            });
          }
        },
      });
    }
  };

  const toggleUnregisteredRetailers = () => {
    setUnregisteredRetailersToggle(!unregisteredRetailersToggle);
    // this.setState({ unregisteredRetailersToggle: !this.state.unregisteredRetailersToggle })
  };

  // useEffect(() => {
  //   const options = CommonHeaderOption();
  //   const apiUrl = RUN_TIME_API_ENDPOINT;
  //   options.method = 'GET';
  //   fetch(`${apiUrl}/so_business_list`, options)
  //     .then(res => {
  //       return res.json();
  //     }).then(jsonD => {
  //       console.log('jsonD ===>', jsonD)
  //       let obj = {};
  //       obj.sap_order_materials = jsonD.data;
  //       obj.loadingShow = false;
  //       // console.log('obj==>', obj);
  //       setSaleOffPhone(obj.sap_order_materials.phone);
  //       setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
  //       setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
  //     });
  // },[])

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/sales_officers/${urlId}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        setSale_officer(obj.sap_order_materials);
        setSaleOffEmail(obj.sap_order_materials.email);
        setSaleOffPhone(obj.sap_order_materials.phone);
        setSaleOffStatus(obj.sap_order_materials.status);
        setIsTradeDeveloper(obj.sap_order_materials.is_trade_developer);
        // setOriginalList(
        //   obj.sap_order_materials.businesses.map((item) => ({
        //     id: item.id,
        //     value: item.label,
        //     label: item.label,
        //   }))
        // );
        // setSaleOffNameSapCode(
        //   obj.sap_order_materials.businesses.map((item) => ({
        //     id: item.id,
        //     value: item.label,
        //     label: item.label,
        //   }))
        // );
        // setSaleOffList(
        //   obj.sap_order_materials.name_sap_code.map((item) => ({
        //     id: item.id,
        //     value: item.name_sap_code,
        //     label: item.name_sap_code,
        //   }))
        // );
        setOriginalList(
          obj.sap_order_materials.businesses.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffNameSapCode(
          obj.sap_order_materials.businesses.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffList(
          obj.sap_order_materials.name_sap_code.map((item) => ({
            id: item.id,
            value: item.name_sap_code,
            label: item.name_sap_code,
            sap: item.sap_code.trim(),
          }))
        );
        // this.setState({
        //   sale_officer: obj.sap_order_materials,
        //   saleOffEmail: obj.sap_order_materials.email,
        //   saleOffPhone: obj.sap_order_materials.phone,
        //   saleOffStatus: obj.sap_order_materials.status,
        //   originalList: obj.sap_order_materials.businesses.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })),
        //   saleOffNameSapCode: obj.sap_order_materials.businesses.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })),
        //   saleOffList: obj.sap_order_materials.name_sap_code.map(item => ({ 'id': item.id, 'value': item.name_sap_code, 'label': item.name_sap_code })),
        // });
      });
  }, []);

  const handleChange = (e) => {
    const arr = [...originalList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
    }
    // console.log('result', result)
    setSaleOffNameSapCode(result);
    setSaleOffList(e);
    // this.setState({
    //   saleOffList: e,
    //   saleOffNameSapCode: result

    // });
  };

  const handleInputChange = (e) => {
    setSaleOffNameSapCode(saleOffNameSapCode);
    // this.setState({ saleOffNameSapCode: this.state.saleOffNameSapCode });
  };

  const emailChange = (e) => {
    // if (/.+@.+\.[A-Za-z]+$/.test(e.target.value) === false) {
    if (
      /([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3})/.test(e.target.value) === false
    ) {
      setValidationError(true);
      setValidationEmailError(true);
      // this.setState({
      //   validationError: true,
      //   validationEmailError: true
      // });
    } else {
      setValidationError(false);
      setValidationEmailError(false);
      // this.setState({
      //   validationError: false,
      //   validationEmailError: false
      // });
    }
    setSaleOffEmail(e.target.value);
    // this.setState({ saleOffEmail: e.target.value });
  };

  const phoneChange = (e) => {
    if (/^\d+$/.test(e.target.value) != true) {
      setValidationError(true);
      setValidationPhoneError(true);
      // this.setState({
      //   validationError: true,
      //   validationPhoneError: true
      // });
    } else {
      setValidationError(false);
      setValidationPhoneError(false);
      // this.setState({
      //   validationError: false,
      //   validationPhoneError: false
      // });
    }

    setSaleOffPhone(e.target.value);
    // this.setState({ saleOffPhone: e.target.value });
  };

  const statusChange = (e) => {
    setSaleOffStatus(e.target.value);
    // this.setState({ saleOffStatus: e.target.value });
  };

  const formSave = () => {
    setShowLoader(true);
    setSaveButtonDisabled(false);
    // this.setState({
    //   showLoader: true,
    //   saveButtonDisabled: false
    // });
    const formData = {
      email: saleOffEmail,
      phone: saleOffPhone,
      status: saleOffStatus,
      name_sap_code: saleOffList,
      is_trade_developer: isTradeDeveloper,
    };

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = "PUT";
    options.body = JSON.stringify({ formData });
    // fetch(`${apiUrl}/sales_officers/${props.id}`, options)
    return fetch(`${apiUrl}/sales_officers/${urlId}`, options)
      .then((res) => {
        console.log("res12...........", res);
        if (res) {
          return res.json();
        }
      })
      .then((res) => {
        if (res.errorMsg) {
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg);
          // this.setState({
          //   errorMsg: true,
          //   showLoader: false,
          //   errorMsgText: res.errorMsg
          // });
          setTimeout(() => {
            setErrorMsg(false);
            setShowLoader(false);
            setSaveButtonDisabled(true);
            // this.setState({
            //   errorMsg: false,
            //   saveButtonDisabled: true
            // });
          }, 3000);
        } else {
          console.log("res...........", res);
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);
          // this.setState({
          //   showLoader: false,
          //   saveButtonDisabled: true,
          //   successMsg: true
          // });
          setTimeout(() => {
            setSuccessMsg(false);
            // this.setState({ successMsg: false });
          }, 2000);
          setTimeout(() => {
            // props.history.push("/sales_officers");
            navigate("/sales_officers");
          }, 3000);
          console.log("res", res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const cancelClick = () => {
    setSaleOffList(null);
    setSaleOffNameSapCode(originalList);
    setUnregisteredRetailers([]);
    setPasrsedSimilarDataLength(0);
    setPasrsedDifferentDataLength(0);
    // this.setState({
    //   saleOffList: null,
    //   saleOffNameSapCode:this.state.originalList
    // });
  };

  return (
    <div className="so-form-container panel-margin-top">
      <div className="so-form">
        <div className="so-input">
          <label>
            Sales officer Email<sup className="asterisk">*</sup>
          </label>
          <input
            className="form-control"
            type="email"
            name="Email"
            value={saleOffEmail}
            onChange={emailChange}
            validations={[required, email]}
            // onBlur={this.handleChange}
          />
          <div className="valid-emailid">
            Enter email with Lafarge Holcim business suite.{" "}
          </div>
          {validationEmailError && (
            <p className="so-input-error">Please enter valid email</p>
          )}
        </div>
        <div className="so-input">
          <label>Sales officer Phone</label>
          <input
            className="form-control"
            type="text"
            name="Phone"
            maxLength="15"
            value={saleOffPhone}
            onChange={phoneChange}
          />
          {validationPhoneError && (
            <p className="so-input-error">Please enter valid phone number</p>
          )}
        </div>

        {/* <label className="select-label">Choose Retailers<sup className="asterisk">*</sup> (Atleast select one retailer)</label>
          <div className="select-retailer">
            <Select
              value={saleOffList}
              onChange={handleChange}
              // onInputChange={this.handleInputChange}
              options={saleOffNameSapCode}
              isMulti
            />
            <button onClick={cancelClick}>Clear</button>
          </div> */}
        <div>
          <div className="csv-file-upload-container target-upload-container">
            <label>Upload File</label>
            {/* <input type="file" accept=".csv" name="flies[]" /> */}
            <input type="file" id="file" accept=".csv" onChange={handleFile} />
            <div className="valid-file-upload">
              <p>Instructions :</p>
              <ul>
                <li>Only CSV files are allowed with Comma as separator.</li>
              </ul>
            </div>
            <div className="upload-file-format-download">
              <p>
                To get upload file format.{" "}
                <a
                  href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                  target="_blank"
                >
                  Click here
                </a>{" "}
                to download
              </p>
            </div>
          </div>

          {pasrsedSimilarDataLength > 0 || pasrsedDifferentDataLength > 0 ? (
            <div className="csv-result-container">
              <label>CSV Result</label>
              <div className="csv-result">
                <div>
                  <p onClick={toggleUnregisteredRetailers}>
                    {pasrsedSimilarDataLength} sales officers found,{" "}
                    {pasrsedDifferentDataLength} sales officers unregistered.
                    {pasrsedDifferentDataLength > 0
                      ? " Click to view unregistererd sales officer"
                      : ""}
                    {pasrsedDifferentDataLength > 0 ? (
                      <span
                        className={
                          unregisteredRetailersToggle
                            ? `icon-arrow_down`
                            : `icon-arrow_up`
                        }
                      />
                    ) : (
                      ""
                    )}
                  </p>
                  {pasrsedDifferentDataLength > 0 ? (
                    <div
                      className={
                        unregisteredRetailersToggle
                          ? `hide-unregistered`
                          : `show-unregistered`
                      }
                    >
                      <React.Fragment>
                        {unregisteredRetailers.map((item) => (
                          <p key={item.id}>{item.label}</p>
                        ))}
                      </React.Fragment>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <label className="select-label">
            Choose Retailers<sup className="asterisk">*</sup> (Atleast select
            one retailer)
          </label>
          <div className="select-retailer">
            <Select
              value={saleOffList}
              onChange={handleChange}
              options={saleOffNameSapCode}
              isMulti
            />
            <button onClick={cancelClick}>Clear</button>
          </div>
        </div>

        <label className="select-label">Login Enabled</label>
        <select
          className="inapp-notification-sendto"
          value={saleOffStatus}
          onChange={statusChange}
        >
          <option value="true">True</option>
          <option value="false">False</option>
        </select>

        {locale == "en-KE" && (
          <>
            <label className="select-label">
              Is this person a Trade Developer<sup className="asterisk">*</sup>
            </label>
            <select
              className="inapp-notification-sendto"
              name="isTradeDeveloper"
              value={isTradeDeveloper}
              onChange={(e) => {
                setIsTradeDeveloper(e.target.value);
              }}
            >
              <option value="">Select Option</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </>
        )}
      </div>
      {saveButtonDisabled && (
        <div className="so-save-button">
          <button
            className={
              !saleOffEmail ||
              (saleOffList == null ? true : !saleOffList.length) ||
              validationEmailError
                ? "disable-save"
                : ""
            }
            disabled={
              validationEmailError ||
              !saleOffEmail ||
              (saleOffList == null ? true : !saleOffList.length)
            }
            onClick={() => formSave()}
          >
            Save
          </button>
        </div>
      )}
      {showLoader && <div className="save-loader" />}
      {successMsg && <div className="so-updated">Successfully updated </div>}
      {errorMsg && <div className="so-email-exist">{errorMsgText}</div>}
    </div>
  );
};

export default SalesOfficersEdit;
